var map = {
	"./0.png": 2957,
	"./1.png": 63012,
	"./2.png": 17663,
	"./3.png": 21334,
	"./4.png": 21161,
	"./5.png": 66336,
	"./6.png": 44667,
	"./7.png": 30450,
	"./8.png": 59605,
	"./9.png": 90508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58202;